import { GenderType } from './../../interface/avatar.interface';
import { LayerItemConfig } from './../../interface/layer.interface';
const noseConfig: LayerItemConfig[] = [
  {
    filename: 'Curve',
    genderType: GenderType.UNSET,
    weight: 10,
  },

  {
    filename: 'Flat',
    genderType: GenderType.UNSET,
    weight: 10,
  },

  {
    filename: 'Pointed',
    genderType: GenderType.UNSET,
    weight: 10,
  },

  {
    filename: 'Round',
    genderType: GenderType.UNSET,
    weight: 10,
  },

  {
    filename: 'tilt',
    genderType: GenderType.UNSET,
    weight: 10,
  },
];

export default noseConfig;
